import { Component } from 'react';
import type { FunctionComponent } from 'react';

import FOSSAHeading from './Heading';
import FOSSAMicro from './Micro';
import FOSSAMonospace from './Monospace';
import FOSSAParagraph from './Paragraph';
import FOSSAText from './Text';

export const Heading = FOSSAHeading;
export const Paragraph = FOSSAParagraph;
export const Monospace = FOSSAMonospace;
export const Micro = FOSSAMicro;

/**
 *  FOSSA Text component, which handles headings, paragraphs, and short spans of text.
 *  Meant to standardize our typographical styles across the app.
 *
 *  @example
 *  import Text from '../generic/Text';
 *  ...
 *  <Text>Some regular text</Text>
 *  <Text.H1>A top-level heading</Text.H1>
 *  <Text.H2>A 2nd-level heading</Text.H2>
 *  <Text.H3>A 3rd-level heading</Text.H3>
 *  <Text.Paragraph>paragraph text</Text.Paragraph>
 *  <Text.Micro>micro text</Text.Micro>
 *
 *  // ...or, just import and use components directly...
 *  import { Heading, Paragraph } from '../generic/Text`;
 *  ...
 *  <Heading level={2}>A 2nd-level heading</Heading>
 *  <Paragraph>paragraph text</Paragraph>
 */
export default class Text extends Component {
  //  Using static like this allows the consumer to use this component like `<Text.Heading>`,
  //  which can help make it more accessible and usable.
  static H1: FunctionComponent = ({ children }) => <Heading level={1}>{children}</Heading>;

  static H2: FunctionComponent = ({ children }) => <Heading level={2}>{children}</Heading>;

  static H3: FunctionComponent = ({ children }) => <Heading level={3}>{children}</Heading>;

  static H4: FunctionComponent = ({ children }) => <Heading level={4}>{children}</Heading>;

  static H5: FunctionComponent = ({ children }) => <Heading level={5}>{children}</Heading>;

  static Heading = Heading;

  static Paragraph = Paragraph;

  static Monospace = Monospace;

  static Micro = Micro;

  static Text = FOSSAText;

  render() {
    const { children } = this.props;
    return (
      <FOSSAText>
        {children}
      </FOSSAText>
    );
  }
}
